import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';


export default class SideMenu extends Component {
	constructor(props) {
        super(props);
        this.state = {
            sideMenuOpen: false
        }
	}


	render() {
		return (
            <div>
                <div onClick={() => this.setState({sideMenuOpen: true})} class={cx("burgerButton")}>
                    <i class="fas fa-bars"></i>
                </div>
                <div class={cx("sideMenu", {"sideMenu-open": this.state.sideMenuOpen})}>
                    <div onClick={() => this.setState({sideMenuOpen: false})} class={cx("burgerButton")} style={{alignSelf: "flex-end"}}>
                        <i class="fas fa-times"></i>
                    </div>
                    <div class={cx("brand")}>
                        <p>🔍 Curatr</p>
                    </div>

                    <div class={cx("menu")}>
                        <p>Menu</p>
                        <a href="/search/list/" class={cx("menu-item", {"menu-item-active": this.props.active == 0})}>
                            <span>Search Engines</span>
                        </a>

                        <a href="/team/management/" class={cx("menu-item", {"menu-item-active": this.props.active == 1})}>
                            <span>Team Management</span>
                        </a>

                        <a href="/logout" class={cx("menu-item")}>
                            <span>Logout</span>
                        </a>
                        
                        {/* <a href="#" class={cx("menu-item")}>
                            <span>Settings</span>
                        </a>

                        <a href="#" class={cx("menu-item")}>
                            <span>Help</span>
                        </a>

                        <a href="#" class={cx("menu-item")}>
                            <span>Log Off</span>
                        </a> */}
                    </div>
                </div>
            </div>
			
		)
	}
}




// WEBPACK FOOTER //
// ./components/sideMenu/index.js